import { Box, Typography, Chip } from "@mui/material";
import {
  LocationOnIcon,
  DeleteIcon,
  PersonIcon,
} from "../../../../../2_ksbHub/icons/icons";

import KsbActionButton from "../../../../../2_ksbHub/components/KsbActionButton";
import SwipeableStudentRow from "./SwipeableStudentRow";

export default function BszStudentRow({
  student,
  remaining,
  isMobile,
  theme,
  onDelete,
}) {
  const isSignedIn = !!student.roomName;

  const rowContent = (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        py: 0.5,
        px: 0.5,
        borderBottom: "1px solid rgba(255,255,255,0.05)",
        gap: 1,
        overflow: "hidden",
      }}
    >
      {/* NAME */}
      <Box
        sx={{
          flex: isMobile ? "0 0 50%" : "0 0 160px",
          minWidth: 0,

          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <PersonIcon
          sx={{
            fontSize: 18,
            opacity: 0.5,
            flexShrink: 0,
          }}
        />

        <Typography
          variant="body2"
          sx={{
            fontWeight: 250,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {student.firstName} {student.lastName}
        </Typography>
      </Box>

      {/* STATUS */}
      <Box
        sx={{
          flex: "1 1 auto",
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          flexWrap: "wrap",
        }}
      >
        {!isSignedIn ? (
          <Typography
            variant="caption"
            sx={{
              color: "error.main",
              whiteSpace: "nowrap",
            }}
          >
            ❌ nicht angemeldet
          </Typography>
        ) : (
          <Chip
            icon={!isMobile ? <LocationOnIcon /> : null}
            label={
              remaining !== null
                ? `${student.roomName} · ${remaining + 1} min`
                : student.roomName
            }
            size="small"
            sx={{
              backgroundColor:
                remaining === null
                  ? undefined
                  : remaining > 10
                    ? "success.main"
                    : remaining > 3
                      ? "warning.main"
                      : "error.main",

              color: remaining !== null ? "white" : undefined,

              "& .MuiChip-icon": {
                color: remaining !== null ? "white" : undefined,
              },
            }}
          />
        )}
      </Box>

      {!isMobile && (
        <Box sx={{ flexShrink: 0 }}>
          <KsbActionButton
            variant="icon"
            label="entfernen"
            icon={<DeleteIcon />}
            desktopIcon={<DeleteIcon />}
            backgroundColor={theme.palette.levels.red}
            sx={{
              opacity: 0.6,
            }}
            onClick={onDelete}
          />
        </Box>
      )}
    </Box>
  );

  if (!isMobile) {
    return rowContent;
  }

  return (
    <SwipeableStudentRow
      deleteButton={
        <KsbActionButton
          variant="icon"
          icon={<DeleteIcon />}
          backgroundColor={theme.palette.levels.red}
          onClick={onDelete}
        />
      }
    >
      {rowContent}
    </SwipeableStudentRow>
  );
}
